<div class="input-wrapper collapsed" #expandable>
    <div class="template-container">

    </div>
    <div class="input-container">
        <div class="input-header">
            <div class="title">
                Add New Banner
            </div>
            <div class="close-button">
                <nb-action>
                    <nb-icon icon="close-circle-outline" pack="eva" (click)="close()"></nb-icon>
                </nb-action> 
            </div>
        </div>
        <div class="input-cell">
            <nb-actions>
                <nb-action>
                    <nb-icon [icon]="collapsed ? 'arrowhead-left-outline' : 'arrowhead-right-outline'"
                        pack="eva" pack="eva" (click)="toggleContainer()">
                    </nb-icon>
                </nb-action>
                <nb-action>
                    Templates
                </nb-action>
            </nb-actions>
        </div>
        <kve-banner-layout-templates [isCreate]="true" (pickLayout)="createBanner($event)"></kve-banner-layout-templates>
    </div>
</div>
